module.exports = __webpack_public_path__ + "static/img/pc_3.6c8579f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pc_3.png
// module id = fDvo
// module chunks = 0